import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import UserService from "services/UserService";
import DelegationService from "services/DelegationService";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setSeconds, differenceInMinutes, setMinutes, differenceInHours, endOfDay, startOfDay, isAfter } from 'date-fns';
import calenderIcon from "assets/user-access/calenderIcon.svg";
import "./Delegation.css"
let setSameRoleChecked = false
const requiredFieldLabel = (label) => (
  <span style={{ fontStyle: 'italic' }}>
    {label}<span style={{ color: 'red' }}>*</span>
  </span>
);

const SelfDelegation = () => {
  const { t, i18n } = useTranslation()
  const location = useLocation();
  const { fromUrl } = location.state || {};
  const { user } = AuthData();
  const navigate = useNavigate();
  const { rowData } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.userName || "");
  const [isActive, setIsActive] = useState(
    rowData?.active === "Active" ? "Active" : "Active"
  );
  const [roleOptions, setRoleOptions] = useState([]);
  const [existDelegation, setExisDelegation] = useState('')
  const [formData, setFormData] = useState({
    profile: rowData?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.profileId || "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
    countryCode: rowData?.countryCode || "",
    fromBatId: "",
    toBatId: "",
    selectedRoles: [],
  });
  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);
  const [StartDate, setStartDate] = useState(rowData?.endDate || "");
  const [exitStartDate, setExistStartDate] = useState(existDelegation[0]?.startDate || "")
  const [exitEndDate, setExistEndDate] = useState(existDelegation[0]?.endDate || "")
  const [countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = {
          batOneId: user?.batOneId,
          pageNumber: 0,
          size: 1000,
          status: null,
        };
        const response = await RoleService.isSelfDelegation(query);
        if (response.data?.statusCode === 200) {
          const apiData = response.data?.response?.delegation;
          if (apiData && apiData[0]?.isActive == true) {
            setBatData(response.data.response?.delegation[0])
            setExisDelegation(response.data.response?.delegation)
            setExistStartDate(apiData[0].startDate)
            setExistEndDate(apiData[0].endDate)
            setFormData((prev) => ({
              ...prev,
              fromBatId: apiData[0]?.fromBATID || "",
              profile: apiData[0]?.toBATID || "",
              remarks: apiData[0]?.remarks || prev.remarks, // Add other mappings as required
            }));
          }
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (error) {
        console.error("API call error:", error);
      }
    };

    if (user?.batOneId) {
      fetchData();
    } else {
      console.warn("batOneId is undefined.");
    }
  }, [user]);

  // Update the handleSubmit function
  const handleSubmit = async (e) => {
    let validateDates = validateDateDifference(startDates, endDates)
    if (validateDates) {
      return
    }

    try {
      // Adjust dates to handle timezone
      const adjustedStartDate = new Date(startDates);
      const adjustedEndDate = new Date(endDates);

      // Add timezone offset to compensate for local timezone
      const startDateISO = new Date(adjustedStartDate.getTime() - (adjustedStartDate.getTimezoneOffset() * 60000)).toISOString();
      const endDateISO = new Date(adjustedEndDate.getTime() - (adjustedEndDate.getTimezoneOffset() * 60000)).toISOString();

      const payload = {
        isActive: isActive === "Active" ? true : false,
        toBATID: formData.profile,
        fromBATID: user?.batOneId,
        startDate: startDateISO,
        endDate: endDateISO,
        delegatedByUser: user.batOneId,
        delegatedProfileIds: formData.selectedRoles || [],
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };

      setLoading(true);
      const response = await DelegationService.createDelegation(payload);
      setLoading(false);
      if (response.status === 201) {
        navigate(`/${fromUrl}`);
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
      } else {
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }

    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(  error?.response?.data?.message  || error?.response?.data?.errorMessage|| error?.message);
        setOpenAlert(true);
      }
    }
  };
  const handleUpdate = () => {
    if (isActive == "Active") {
      navigate(`/${fromUrl}`)
    } else {
      let data = {
        delegation: existDelegation[0]?.delegationId,
        delegatedByUser: user.batOneId,
      }
      RoleService.updateDelegation(data)
        .then((res) => {
          setMessage("Updated Successfully")
          setOpenAlert(true)
          setSeverity("success")
          navigate(`/${fromUrl}`)
        })
        .catch((error) => {
          setMessage(error?.response?.data?.errorMessage || error?.message);
          setOpenAlert(true)
          setSeverity("error")
          console.error("API call failed:", error);
        })
    }

  }
  const [match, setMatch] = useState(false);
  const handleChangeText = (e) => {
    setFormData({ ...formData, profile: e.target.value });
  };
  const [batData, setBatData] = useState("");
  const [open, setOpen] = useState(false);
  const fetchProfileData = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query.profile) {
        if (query?.batOneId == query?.profile) {
          setSeverity("error");
          setMessage("Cannot delegate to myself");
          setOpenAlert(true);
          return
        }
        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: query?.batOneId,
            delegatorBATID: query?.profile,
          });
          setLoading(false);
          setSameRoleChecked = true;

          // Transform activeRoles object into array of {id, value} objects
          if (response?.data?.response?.activeRoles) {
            const roles = Object.entries(response.data.response.activeRoles).map(([id, value]) => ({
              id,
              value
            }));
            setRoleOptions(roles);
          }

          if (response?.data?.response !== match) {
            setMatch(response?.data?.response);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching profile data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message ? error?.response?.data?.message : error?.message);
          setOpenAlert(true);
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  useEffect(() => {
    fetchProfileData({ profile: formData.profile, batOneId: user?.batOneId });
  }, [ formData.profile]);


  const [multiMatch, setMultiMatch] = useState(false);
  const fetchProfileData2 = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query?.fromBatId && query?.toBatId) {
        if (query?.fromBatId == query?.toBatId) {
          setSeverity("error");
          setMessage("Cannot delegate to myself");
          setOpenAlert(true);
          return
        }
        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: query?.fromBatId,
            delegatorBATID: query?.toBatId,
          });
          setLoading(false);
          setSameRoleChecked = true
          // Only update state if the component is still mounted and the response is different
          if (query?.isMounted && response?.data?.response !== multiMatch) {
            setMultiMatch(response?.data?.response);
          }
        } catch (error) {
          setLoading(false);
          if (query?.isMounted) {
            console.error("Error fetching profile data:", error);
            setSeverity("error");
            setMessage(error?.response?.data?.message || "An error occurred");
            setOpenAlert(true);
          }
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );


  useEffect(() => {
    let isMounted = true; // Track if the component is mounted
    if (setSameRoleChecked == true) return
    fetchProfileData2({ profile: formData.profile, fromBatId: formData.fromBatId, toBatId: formData.toBatId, isMounted: isMounted });
    return () => {
      isMounted = false; // Cleanup function to avoid state updates if unmounted
    };
  }, [formData.fromBatId, formData.toBatId, multiMatch]); // Add 'match' to dependency array if you want the effect to re-run when it changes

  useEffect(() => {
    const fetchUserData = async () => {
      if (match) {
        try {
          const response = await UserService.FindAdUser(formData.profile);
          // Only update state if the response is different
          setBatData(response?.data?.response);
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(`${formData?.profile} One ID does not exist in Agri360 system`);
          setOpenAlert(true);
        }
      }
    };

    fetchUserData();
  }, [match]); // Depend on match to avoid unnecessary re-renders

  const [userEmail, setUserEmail] = useState("");
  const fetchUserData = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query.fromBatId) {
        try {
          const response = await UserService.FindAdUser(query.fromBatId);
          // Only update state if the response is different
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
          setUserEmail(response?.data?.response?.mail);
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(`${formData?.fromBatId} One ID does not exist in Agri360 system`);
          setOpenAlert(true);
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  useEffect(() => {
    fetchUserData({ fromBatId: formData.fromBatId });
  }, [formData.fromBatId]);

  const [toUserName, setToUserName] = useState("");
  const [toEmail, setToEmail] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (multiMatch) {
        try {
          const response = await UserService.FindAdUser(formData.toBatId);
          // Only update state if the response is different
          setToUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );

          setToEmail(response?.data?.response?.mail);
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(`${formData?.toBatId} One ID does not exist in Agri360 system`);
          setOpenAlert(true);
        }
      }
    };
    fetchUserData();
  }, [multiMatch]);
  const toggleIsActive = () => {
    setIsActive((prevIsActive) =>
      prevIsActive === "Active" ? "InActive" : "Active"
    );
  };

  const handleChangeDate = (date) => {
    setStartDate(date); // Store the selected date
  };

  const handleChangeDateExistStart = (date) => {
    setExistStartDate(date); // Store the selected date
  };

  const [endDate, setEndDate] = useState("");

  const [openEnd, setOpenEnd] = useState(false);

  const handleChangeDateEnd = (date) => {
    setEndDate(date); // Store the selected date
  };
  const handleChangeDateEndExist = (date) => {
    setExistEndDate(date); // Store the selected date
  };
  const editFlag = false;

  const [startDates, setStartDates] = React.useState(() => {
    const now = new Date();
    // Round up to the next hour
    const nextHour = new Date(now);
    nextHour.setHours(now.getHours() + 1, 0, 0, 0);
    return nextHour;
  });

  const [endDates, setEndDates] = React.useState(
  );

  const [minTime, setMinTime] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  useEffect(() => {
    const now = new Date();
    // Set minTime to current time for today
    setMinTime(now);
    // Set maxTime to end of day
    setMaxTime(setHours(endOfDay(now), 23));
  }, []);

  const handleStartDateChange = (date) => {
    if (date) {
      const now = new Date();
      const selectedDate = new Date(date);
      
      // If selected date is today and selected time is past
      if (selectedDate.toDateString() === now.toDateString() && selectedDate < now) {
        // Round up to the next hour from current time
        const nextHour = new Date(now);
        nextHour.setHours(now.getHours() + 1, 0, 0, 0);
        setStartDates(nextHour);
      } else {
        // For future dates or valid times, keep the selected time
        setStartDates(selectedDate);
      }
    }
  };

  const handleEndDateChange = (date) => {
    setEndDates(date);
    if (startDates) {
      validateDateDifference(startDates, date);
    }
  };

  const validateDateDifference = (startDate, endDate) => {
    let status = false
    const startWithoutTimeDetails = setSeconds(setMinutes(startDate, 0), 0);
    const endWithoutTimeDetails = setSeconds(setMinutes(endDate, 0), 0);
    const minutesDifference = differenceInMinutes(endWithoutTimeDetails, startWithoutTimeDetails);
    if (minutesDifference < 59) {
      setSeverity("error");
      setMessage("Difference between from and To Date & time should be more then 1 hour.");
      setOpenAlert(true);
      status = true
    }
    return status
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <>
          {existDelegation === "" ?
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "65vh",
                background: "#f0f3f6",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                padding: "25px",
                borderRadius: "6px",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {toUserName === "" && (
                <Box
                  sx={{
                    background: "#ffffff",
                    width: "473px",
                    display: "flex",
                    flexDirection: "column",
                    // gap: "15px",
                    borderRadius: "16px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                >
                  <Box sx={{ p: 2 }}>
                    <TextField
                      id="profile"
                      label={<>{t("otherDelegation.batOneId")}<span style={{ color: 'red' }}>*</span></>}
                      InputLabelProps={{
                        style: { fontStyle: 'italic' }
                      }}
                      InputProps={{
                        endAdornment: (
                          <img
                            src={require('assets/user-access/inputSearch.png')}
                            alt="search"
                            style={{ width: '20px', height: '20px' }}
                          />
                        ),
                      }}
                      value={formData.profile}
                      name="profile"
                      onChange={handleChangeText}
                      disabled={batData?.givenName}
                      fullWidth
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                    ></TextField>
                  </Box>
                  {batData === "" && (
                    <Box sx={{ p: 0, mb: 4, textAlign: "center" }}>
                      <Button
                        sx={{
                          borderRadius: 2,
                          background: "#102A62",
                          height: 50,
                          color: "#ffffff",
                          fontWeight: 600,
                          backgroundColor: "#737D86",
                          width: "100px",
                          marginTop: "20px",
                          "&:hover": {
                            backgroundColor: "#737D86",
                          },
                        }}
                        onClick={() => navigate(-1)}
                      >
                        {t("back")}
                      </Button>
                    </Box>
                  )}

                  {batData !== "" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: 500,
                        color: "#191E31",
                        borderBottom: "2px solid #CFD5E0",
                        p: 2,
                      }}
                    >
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        {t("administratorAccess.name")}:{" "}
                        {`${batData?.givenName ?? ""} ${batData?.surName ?? ""}`}
                      </Typography>
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        {t("administratorAccess.email")}: {batData?.mail ?? ""}
                      </Typography>
                    </Box>
                  )}
                  {batData !== "" && (
                    <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="role-name-label" sx={{
                          fontStyle: 'italic',
                          color: '#112a63',
                          backgroundColor: 'white',
                          padding: '0 8px',
                          '&.Mui-focused': {
                            color: '#112a63',
                          }
                        }}>{t("Role Name")}</InputLabel>
                        <Select
                          labelId="role-name-label"
                          multiple
                          value={formData.selectedRoles || []}
                          onChange={(event) => {
                            const { value } = event.target;
                            setFormData(prev => ({
                              ...prev,
                              selectedRoles: value
                            }));
                          }}
                          renderValue={(selected) => {
                            const selectedValues = selected.map(value => 
                              roleOptions.find(role => role.id === value)?.value || value
                            ).join(', ');
                            return (
                              <Tooltip title={selectedValues} arrow placement="top">
                                <Box sx={{ 
                                  display: 'flex', 
                                  flexWrap: 'wrap', 
                                  gap: 0.5,
                                  maxWidth: 'calc(100% - 8px)',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}>
                                  {selectedValues}
                                </Box>
                              </Tooltip>
                            );
                          }}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 250,
                                overflow: 'auto'
                              }
                            }
                          }}
                        >
                          {roleOptions.map((role) => (
                            <MenuItem key={role.id} value={role.id}>
                              <Checkbox
                                checked={(formData.selectedRoles || []).indexOf(role.id) > -1}
                                icon={<img src={CheckboxUntick} />}
                                checkedIcon={<img src={CheckboxTick} />}
                              />
                              <ListItemText primary={role.value} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <Box className="main-area">
                        <div className="datepicker-container">
                          <DatePicker
                            selected={startDates}
                            minDate={new Date()}
                            onChange={handleStartDateChange}
                            showTimeSelect
                            minTime={minTime}  // Disable past time
                            maxTime={maxTime}  // Set max time to the end of the day
                            timeIntervals={60}
                            dateFormat="dd/MM/YYYY | HH:mm"
                            timeFormat="HH:mm"
                            placeholderText="Start Date"
                            timeZoneOffsetInMinutes={0} // Add this line
                            customInput={
                              <TextField
                                label={requiredFieldLabel("Start Date")}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    fontSize: '16px',
                                    padding: '10px',
                                  },
                                }}
                                InputLabelProps={{
                                  style: { fontStyle: 'italic' },
                                  shrink: !!startDates,
                                }}
                              />
                            }
                          />
                          <img src={calenderIcon} className="datepicker-icon" />
                        </div>
                      </Box>
                      <Box sx={{ marginTop: "20px" }} className="main-area">
                        <div className="datepicker-container">
                          <DatePicker
                            selected={endDates}
                            minDate={new Date(startDates)}
                            onChange={handleEndDateChange}
                            showTimeSelect
                            timeIntervals={60}
                            dateFormat="dd/MM/YYYY | HH:mm"
                            timeFormat="HH:mm"
                            placeholderText="End Date"
                            timeZoneOffsetInMinutes={0} // Add this line
                            customInput={
                              <TextField
                                label={requiredFieldLabel("End Date")}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    fontSize: '16px',
                                    padding: '10px', // You can adjust this to match Material-UI's input styling
                                  },
                                }}
                                InputLabelProps={{
                                  style: { fontStyle: 'italic' },
                                  shrink: !!endDates, // Only shrink label when there's a value
                                }}
                              />
                            }
                          />
                          <img src={calenderIcon} className="datepicker-icon" />
                        </div>
                      </Box>
                    </Box>
                  )}

                  {batData !== "" && (
                    <>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            pb: 2,
                            cursor: "pointer",
                            borderBottom: "2px solid #CFD5E0",
                          }}
                          onClick={toggleIsActive}
                        >
                          <img
                            src={
                              isActive === "Active" ? CheckboxTick : CheckboxUntick
                            }
                            alt="checkbox"
                          />
                          <Typography>
                            {isActive === "Active" ? "Active" : "Inactive"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          gap: "20px",
                          p: 2,
                        }}
                      >
                        <Button
                          sx={{
                            borderRadius: 2,
                            background: "#102A62",
                            height: 54,
                            color: "#ffffff",
                            fontWeight: 600,
                            backgroundColor: "#737D86",
                            width: { xs: "100%", md: "156px" },
                            "&:hover": {
                              backgroundColor: "#737D86",
                            },
                          }}
                          onClick={() => navigate(-1)}
                        >
                          {t("back")}
                        </Button>
                        <Button
                          sx={{
                            borderRadius: 2,
                            background: "#EF7D00",
                            color: "#ffffff",
                            fontWeight: 600,
                            height: 54,
                            width: { xs: "100%", md: "156px" },
                            "&:hover": {
                              backgroundColor: "#EF7D00",
                            },
                          }}
                          disabled={loading || !startDates || !endDates || formData.selectedRoles.length === 0}
                          onClick={() => handleSubmit()}
                        >
                          {t("assign")}
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              )}
            </Box>
            :
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "65vh",
                background: "#f0f3f6",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                padding: "25px",
                borderRadius: "6px",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              {toUserName === "" && (
                <Box
                  sx={{
                    background: "#ffffff",
                    width: "473px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    borderRadius: "16px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                  }}
                >
                  <Box sx={{ borderBottom: "2px solid #CFD5E0", p: 2 }}>
                    <TextField
                      id="profile"
                      label={t("otherDelegation.batOneId")}
                      value={existDelegation[0]?.toBATID}
                      name="profile"
                      onChange={handleChangeText}
                      disabled={true}
                      fullWidth
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                    ></TextField>
                  </Box>

                  {batData !== "" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: 500,
                        color: "#191E31",
                        borderBottom: "2px solid #CFD5E0",
                        p: 2,
                      }}
                    >
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        {t("administratorAccess.name")}:{" "}
                        {existDelegation[0].toName}

                      </Typography>
                      <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                        {t("administratorAccess.email")}:

                        {existDelegation[0].toEmail}

                      </Typography>
                    </Box>
                  )}
                  {batData !== "" && (
                    <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>
                      <Box className="main-area">
                        <div className="datepicker-container">
                          <DatePicker
                            selected={startDates}
                            minDate={new Date()}
                            minTime={minTime}  // Disable past time
                            maxTime={maxTime}  // Set max time to the end of the day
                            onChange={handleStartDateChange}
                            showTimeSelect
                            timeIntervals={60}
                            dateFormat="dd/MM/YYYY | HH:mm"
                            timeFormat="HH:mm"
                            placeholderText="Start Date"
                            timeZoneOffsetInMinutes={0} // Add this line
                            customInput={
                              <TextField
                                label={requiredFieldLabel("Start Date")}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    fontSize: '16px',
                                    padding: '10px',
                                  },
                                }}
                                InputLabelProps={{
                                  style: { fontStyle: 'italic' },
                                  shrink: !!startDates,
                                }}
                              />
                            }
                          />
                          <img src={calenderIcon} className="datepicker-icon" />
                        </div>
                      </Box>
                      <Box sx={{ marginTop: "20px" }} className="main-area">
                        <div className="datepicker-container">
                          <DatePicker
                            selected={endDates}
                            minDate={new Date(startDates)}
                            onChange={handleEndDateChange}
                            showTimeSelect
                            timeIntervals={60}
                            dateFormat="dd/MM/YYYY | HH:mm"
                            timeFormat="HH:mm"
                            placeholderText="End Date"
                            timeZoneOffsetInMinutes={0} // Add this line
                            customInput={
                              <TextField
                                label="End Date"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                  style: {
                                    fontSize: '16px',
                                    padding: '10px', // You can adjust this to match Material-UI's input styling
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: !!endDates, // Only shrink label when there's a value
                                }}
                              />
                            }
                          />
                          <img src={calenderIcon} className="datepicker-icon" />
                        </div>
                      </Box>
                    </Box>
                  )}

                  {batData !== "" && (
                    <>
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            pb: 2,
                            cursor: "pointer",
                            borderBottom: "2px solid #CFD5E0",
                          }}
                          onClick={toggleIsActive}
                        >
                          <img
                            src={
                              isActive === "Active" ? CheckboxTick : CheckboxUntick
                            }
                            alt="checkbox"
                          />
                          <Typography>
                            {isActive === "Active" ? "Active" : "Inactive"}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          gap: "20px",
                          p: 2,
                        }}
                      >
                        <Button
                          sx={{
                            borderRadius: 2,
                            background: "#102A62",
                            height: 54,
                            color: "#ffffff",
                            fontWeight: 600,
                            backgroundColor: "#737D86",
                            width: { xs: "100%", md: "156px" },
                            "&:hover": {
                              backgroundColor: "#737D86",
                            },
                          }}
                          onClick={() => navigate(-1)}
                        >
                          {t("back")}
                        </Button>
                        <Button
                          sx={{
                            borderRadius: 2,
                            background: "#EF7D00",
                            color: "#ffffff",
                            fontWeight: 600,
                            height: 54,
                            width: { xs: "100%", md: "156px" },
                            "&:hover": {
                              backgroundColor: "#EF7D00",
                            },
                          }}
                          onClick={() => handleUpdate()}
                        >
                          {t("update")}
                        </Button>
                      </Box>
                    </>
                  )}
                </Box>
              )}
            </Box>
          }
        </>

      </Box>
    </LayoutAccessManagement>
  );
};

export default SelfDelegation;
